<template>
  <button
    class="inline-flex items-center justify-center mt-4 px-8 py-2 font-semibold transition-colors rounded-md focus:outline-none"
    :class="{ primary, secondary }"
    >
    <slot></slot>
  </button>
</template>

<script>

  export default {
    name: 'YogoButton',
    components: {
    },
    data: () => ({

    }),
    props: {
      primary: Boolean,
      secondary: Boolean
    }
  }
</script>

<style lang="scss" scoped>
  .primary {
    @apply bg-blue-600;
    @apply text-white;
    @apply hover:bg-blue-700;
  }
  .secondary {
    @apply px-8;
    @apply py-3;
    @apply border;
    @apply border-transparent;
    @apply text-base;
    @apply font-medium;
    @apply rounded-md;
    @apply text-blue-700;
    @apply bg-blue-100;
    @apply hover:bg-blue-200;
    @apply md:py-2;
    @apply md:text-base;
    @apply md:px-4;
  }
</style>
